import React, { Component } from 'react';
import Chart from 'chart.js/auto';

export default class GreenChart extends Component {
  constructor(props) {
    super(props);

    // Create a ref for the chart canvas element
    this.chartRef = React.createRef();
    // Store the Chart.js instance
    this.chartInstance = null;
    // Intersection Observer instance to detect when the chart is in view
    this.intersectionObserver = null;
  }

  componentDidMount() {
    // Initialize Intersection Observer to handle chart visibility
    this.intersectionObserver = new IntersectionObserver(this.handleIntersection, {
      threshold: 0.8, // Adjust the threshold as needed
    });

    // Start observing the chart canvas
    this.intersectionObserver.observe(this.chartRef.current);
  }

  componentWillUnmount() {
    // Disconnect the Intersection Observer when the component unmounts
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
    }
  }

  // Callback for Intersection Observer
  handleIntersection = (entries) => {
    const chartEntry = entries[0];
    if (chartEntry.isIntersecting) {
      this.initializeChart(); // Initialize the chart when in view
      this.intersectionObserver.disconnect(); // Disconnect the observer once initialized
    }
  };

  // Initialize the Chart.js chart
  initializeChart = () => {
    const chartCanvas = this.chartRef.current;
    const ctx = chartCanvas.getContext('2d');

    // Create a new Chart instance
    this.chartInstance = new Chart(ctx, {
      type: 'bar', // Set the chart type
      data: {
        labels: [
          "Cleaning and Breakroom Supplies",
          "Copy and Print Depot",
          "Filing and Binding",
          "Furniture",
          "Ink and Toner",
          "Labels and Forms",
          "Office Essentials",
          "Paper",
          "Technology",
          "Writing and Drafting",
          "Miscellaneous",
        ],
        datasets: [
          {
            data: [
              7734.16, 0, 15223.59, 1866.15, 651617.7, 29354.05, 24859.43, 10544.95, 2525.28, 71274.61, 84.34
            ],
            label: 'Light Green', // Dataset label
            backgroundColor: '#c1d730', // Background color
          },
          {
            data: [
              25174.37, 0, 13088.55, 485.34, 159042.78, 2098.4, 7791.45, 80048.34, 474.65, 3031.83, 1514.87
            ],
            label: 'Mid Green', // Dataset label
            backgroundColor: '#6db341', // Background color
          },
          {
            data: [
              725.31, 0, 2887.84, 1515.04, 1301.65, 468.26, 2525.98, 0, 19.92, 29.19, 44.58
            ],
            label: 'Dark Green', // Dataset label
            backgroundColor: '#04703c', // Background color
          },
          {
            data: [
              7564.74, 0, 12.29, 0, 0, 0, 6605.59, 155226.66, 7040.9, 0, 90.32
            ],
            label: 'Meets Norms', // Dataset label
            backgroundColor: '#53d9c3', // Background color
          },
          {
            data: [
              2409.98, 117.72, 265.45, 0, 0, 412.41, 3.89, 202.42, 753.59, 2762.59, 0
            ],
            label: 'Not Green', // Dataset label
            backgroundColor: '#fed500', // Background color
          },
        ],
      },
      options: {
        indexAxis: 'y', // Horizontal bar chart
        animation: {
          duration: 500,
          easing: 'easeOut',
        },
        layout: {
          padding: 20,
        },
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
            position: 'bottom',
            align: 'start',
            onClick: null,
            labels: {
              boxWidth: 10,
              boxHeight: 10,
            },
          },
        },
        scales: {
          x: {
              stacked: true, // IMPORTANT for stacked bar totals
              min: 0,
              max: 1000000,
              grid: {
                display: true,
                drawBorder: false,
              },
              ticks: {
                stepSize: 200000,
                font: {
                  family: "'Encode Sans', sans-serif",
                },
                callback: function (value) {
                  return `$${value.toLocaleString()}`;
                },
              },
            },
          y: {
            border: {
              display: false,
            },
            stacked: true,
            grid: {
              display: false,
            },
            ticks: {
              font: {
                family: "'Encode Sans', sans-serif",
                size: window.innerWidth < 992 ? 8 : 10,
              },
            },
          },
        },
        interaction: {
          // Disable hover and click interactions
          mode: 'none',
          intersect: false,
        },
        onClick: null, // Disable click interactions
      },
    });

    this.chartInstance.update(); // Update the chart
  };

  render() {
    return (
      <div className='chartRow' style={{ height: '400px' }}>
        {/* Chart canvas */}
        <canvas id={`chart-${this.props.id}`} ref={this.chartRef} className='disable-hover' />
      </div>
    );
  }
}
